import { ComponentProps, Fragment } from 'react';
import { Dimensions, StyleSheet } from 'react-native';
import { ContentLoader, Rect, Circle } from '@pletly/ui';

const DEFAULT_ITEMS_COUNT = 5;
const ITEM_HEIGHT = 80;

type Props = ComponentProps<typeof ContentLoader> & {
	itemsCount?: number;
};

export const Loader = ({ itemsCount = DEFAULT_ITEMS_COUNT, ...contentLoaderProps }: Props) => (
	<ContentLoader
		key="7"
		speed={2}
		width={Dimensions.get('window').width}
		height={667}
		viewBox="0 0 375 667"
		backgroundColor="#E8E7E1"
		foregroundColor="#ecebeb"
		style={styles.root}
		{...contentLoaderProps}
	>
		{Array.from({ length: itemsCount }).map((_, index) => (
			<Fragment key={index}>
				<Circle cx="36" cy={120 + ITEM_HEIGHT * index} r="20" />
				<Rect x="64" y={103 + ITEM_HEIGHT * index} rx="3" ry="3" width="250" height="15" />
				<Rect x="64" y={122 + ITEM_HEIGHT * index} rx="3" ry="3" width="250" height="15" />
				<Rect y={160 + ITEM_HEIGHT * index} width="100%" height="2" />
			</Fragment>
		))}
	</ContentLoader>
);

const styles = StyleSheet.create({
	root: {
		transform: [{ translateY: -80 }],
	},
});
